import _ from 'lodash'
import AscentiaService from './ascentiaService'

const values = {
  filter: null,
  filterUpdate: null,
  filterDelete: null,
}

const getters = {
  filter() {
    try {
      const savedSelectionsStr = window.localStorage.getItem('AscentiaFilters')
      if (savedSelectionsStr) {
        const savedSelections = JSON.parse(savedSelectionsStr)
        return savedSelections
      }
      return {}
    } catch (error) {
      console.log(
        'Failed to load previously selected parameter filters: ' + error,
      )
    }
  },
}

const saves = {
  filterUpdate({ key, filter, filterCollection }) {
    try {
      const filterToSave = _.cloneDeep(filterCollection || {})
      let currentFilter = filterToSave[key] || []

      if (filter.id) {
        if (currentFilter.some(cf => cf.id === filter.id)) {
          currentFilter = currentFilter.map(cf => {
            if (cf.id === filter.id) {
              return filter
            }
            return cf
          })
        } else {
          currentFilter.push(filter)
        }
      }

      filterToSave[key] = currentFilter
      window.localStorage.setItem(
        'AscentiaFilters',
        JSON.stringify(filterToSave),
      )
      return filterToSave
    } catch (error) {
      console.log(
        'Failed to save previously selected parameter filters: ' + error,
      )
    }
  },
}

const deletes = {
  filterDelete({ key, ids, filterCollection }) {
    try {
      const filterToSave = _.cloneDeep(filterCollection || {})
      if (ids) {
        // Only keep if ID isn't passed in
        filterToSave[key] = filterToSave[key].filter(
          cf => ids.indexOf(cf.id) === -1,
        )
      } else {
        filterToSave[key] = null
      }
      window.localStorage.setItem(
        'AscentiaFilters',
        JSON.stringify(filterToSave),
      )
      return filterToSave
    } catch (error) {
      console.log(
        'Failed to save previously selected parameter filters: ' + error,
      )
    }
  },
}

export default class FilterService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
